module.exports = __webpack_public_path__ + "static/media/filter.ba03fc6f.svg";